<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('schedule.edit')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <name-text-field v-model="scheduleName"></name-text-field>
    <scene-selector v-model="scheduleScenes" :label="$t('schedule.scenes')" :rules="sceneRules" multiple clearable></scene-selector>
    <timezone-selector v-model="scheduleTimezone" required></timezone-selector>
    <time-selector v-model="scheduleTime" required></time-selector>
    <weekday-selector v-model="scheduleDays" required></weekday-selector>
  </v-form>

  <contact-selector v-model="scheduleContacts" :label="$t('schedule.emails_to_notify')"></contact-selector>

  <v-switch v-model="scheduleEnabled" class="mx-2 my-2 pa-0" :label="$t(`schedule.${scheduleEnabled?'enabled':'disabled'}`)"></v-switch>

  <template slot="actions">
    <v-btn v-if="isExisted" :disabled="saving" flat color="red" @click="remove">{{ $t('schedule.delete') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn :disabled="!validEditor" :loading="saving" flat color="primary" @click="save">{{ $t('schedule.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import TimeSelector from './TimeSelector'
import TimezoneSelector from './TimezoneSelector'
import WeekdaySelector from './WeekdaySelector'
import SceneSelector from '@/components/scene/SceneSelector'
import ContactSelector from '@/components/contact/ContactSelector'

export default {
  name: 'ScheduleEditorDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField,
    'time-selector': TimeSelector,
    'timezone-selector': TimezoneSelector,
    'scene-selector': SceneSelector,
    'contact-selector': ContactSelector,
    'weekday-selector': WeekdaySelector
  },
  data() {
    return {
      saving: false,
      validEditor: false,
      scheduleName: null,
      scheduleTimezone: null,
      scheduleTime: null,
      scheduleDays: null,
      scheduleScenes: [],
      scheduleEnabled: true,
      sceneRules: [
        v => v.length > 0 || this.$t('schedule.scenes_required'),
        v => v.length <= 10 || this.$t('schedule.max_scenes_limit', {
          max: '10'
        })
      ],
      scheduleContacts: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isExisted() {
      return !!(this.data || {}).key;
    },
    contactToSave() {
      return this.scheduleContacts.reduce((acc, cur) => {
        acc[cur] = this.userContact[cur];
        return acc;
      }, {});
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      let ref = this.$db.ref('userSchedule').child(this.userId);
      if (this.isExisted)
        ref = ref.child(this.data.key);
      else
        ref = ref.push();
      try {
        await ref.set({
          name: this.scheduleName,
          timezone: this.scheduleTimezone,
          time: this.scheduleTime,
          days: this.scheduleDays || [],
          scenes: this.scheduleScenes || [],
          enabled: this.scheduleEnabled,
          notify: this.contactToSave
        });
      } catch (err) {
        this.$emit('toast', this.$t('schedule.permission_denied'));
        this.saving = false;
        return;
      }
      this.visible = false;
    },
    async remove() {
      let ref = this.$db.ref('userSchedule').child(this.userId).child(this.data.key).remove()
        .then(() => this.visible = false)
        .catch(err => console.log(err));
    }
  },
  mounted() {
    if (this.data) {
      this.scheduleName = this.data.name;
      this.scheduleTimezone = this.data.timezone;
      this.scheduleTime = this.data.time;
      this.scheduleDays = this.data.days || [];
      this.scheduleScenes = this.data.scenes || [];
      this.scheduleEnabled = this.data.enabled;
      this.scheduleContacts = Object.keys(this.data.notify || {}) || [];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleEditorDialog.vue